import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const createPayrollGivingOrderMutation = gql`
  mutation CreatePayrollGivingQuote($input: CreatePayrollGivingOrderInput!) {
    createPayrollGivingQuote(input: $input) {
      createPayrollGivingQuote {
        order {
          id
        }
        errors {
          fieldName
          message
        }
      }
    }
  }
`

export const getCreatePayrollGivingOrderMutationKey = getQueryNames(createPayrollGivingOrderMutation)[0]
export {createPayrollGivingOrderMutation}
